/** @jsx jsx */
import { jsx } from 'theme-ui'
import { number, string } from 'prop-types'

const ChevronRight = ({
  color = '#92D3F3',
  height = 13,
  width = 7,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      {...props}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="5.8009"
        y1="6.47639"
        x2="0.70707"
        y2="11.5702"
        stroke={color}
        strokeLinecap="round"
      />
      <line
        x1="0.906204"
        y1="0.999756"
        x2="6.00004"
        y2="6.09359"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

ChevronRight.propTypes = {
  color: string,
  height: number,
  width: number,
}

export default ChevronRight
